<template>
    <div>
        <v-card-title>
            <strong>{{ $t('customer.breadcrumbs.index') }}</strong>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('sarala-table.labels.search')"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>

        <v-data-table
            :headers="tableHeaders"
            :items="customers"
            :search="search"
            :items-per-page="5"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            icon
                            tile
                            v-on="on"
                            @click="
                                $router.push({
                                    name: 'customer.show',
                                    params: { id: item.id },
                                })
                            "
                        >
                            <v-icon color="light-green darken-2" v-on="on"
                                >mdi-account-details</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>{{ $t('partner.customers.show') }}</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: ['customers'],

    data() {
        return {
            search: '',
        }
    },

    computed: {
        tableHeaders() {
            return [
                {
                    text: this.$t('partner.customers.trade-name'),
                    align: 'left',
                    sortable: false,
                    value: 'trade_name',
                },
                {
                    text: this.$t('customer.index.table.status'),
                    value: 'readable_status',
                    sortable: false,
                },
                {
                    text: this.$t('tables.actions'),
                    align: 'right',
                    sortable: false,
                    value: 'action',
                },
            ]
        },
    },
}
</script>
